import React, { ReactElement } from "react";
import Tooltip from "rc-tooltip";
import { css } from "@emotion/css";
import "rc-tooltip/assets/bootstrap.css";

export interface TooltipWrapperProps {
    text?: string | ReactElement;
    className?: string;
    place?: 'left' | 'right' | 'top' | 'bottom' | 'topLeft' | 'topRight' |
    'bottomLeft' | 'bottomRight' | 'rightTop' | 'rightBottom' | 'leftTop' | 'leftBottom' | string;
    replacementContentStyle?: string;
    mouseEnterDelay?: number;
    maxWidth?: number | string;
}

const TooltipWrapper: React.FC<TooltipWrapperProps> = (props) => {
    const getTooltipStyle = () => {
        const mw = props.maxWidth;
        const maxWidthValue = mw
            ? (typeof mw === 'number' ? `${mw}px` : mw)
            : undefined;

        return css`
            .rc-tooltip-inner {
                font-family: Muli;
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                letter-spacing: 0.6px;
                z-index: 120;
                color: white;
                background-color: #304562;
                box-shadow: -1px 4px 10px 0 rgba(48, 69, 98, 0.1);
                padding: 8px;
                min-height: 0;
                white-space: normal;
                word-wrap: break-word;
                ${maxWidthValue ? `max-width: ${maxWidthValue};` : ''}
            }
        `;
    };

    return (
        <Tooltip
            mouseEnterDelay={props.mouseEnterDelay ? props.mouseEnterDelay : 0.5}
            overlayClassName={
                props.replacementContentStyle
                    ? props.replacementContentStyle
                    : getTooltipStyle() + " " + props.className
            }
            placement={props.place === undefined ? "top" : props.place}
            trigger={["hover"]}
            overlay={
                <span>{props.text}</span>
            }
        >
            {props.children}
        </Tooltip>
    );
};

export default TooltipWrapper;
